import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { DEFAULT_CURRENCY_CODE, inject, LOCALE_ID } from "@angular/core";
import { Observable } from "rxjs";

export const i18nInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const currency = inject(DEFAULT_CURRENCY_CODE);
  const locale = inject(LOCALE_ID);

  return next(req.clone({ setHeaders: { "currency": currency, "locale": locale } }));
}